import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "pt-8 card-body pb-0" }
const _hoisted_3 = { class: "fs-6 text-gray-400 m-0" }
const _hoisted_4 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-2" }
const _hoisted_5 = { class: "card-header border-0 pt-6" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex justify-content-end gap-2",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_12 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_inbound_receiving_package"
}
const _hoisted_13 = { class: "svg-icon svg-icon-3" }
const _hoisted_14 = {
  key: 1,
  class: "me-0"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_17 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_18 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_22 = { class: "menu-item px-3" }
const _hoisted_23 = [":class"]
const _hoisted_24 = { class: "menu-item px-3" }
const _hoisted_25 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_27 = { class: "menu-item px-3" }
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_29 = { class: "card-body pt-0" }
const _hoisted_30 = { class: "fs-7 text-gray-400 mw-100px text-line-clamp-1" }
const _hoisted_31 = {
  key: 0,
  class: "svg-icon svg-icon-3 svg-icon-success"
}
const _hoisted_32 = {
  key: 1,
  class: "svg-icon svg-icon-3 svg-icon-warning"
}
const _hoisted_33 = {
  key: 2,
  class: "svg-icon svg-icon-3 svg-icon-danger"
}
const _hoisted_34 = { class: "fs-7 text-gray-400" }
const _hoisted_35 = { class: "fs-7 text-gray-400" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_38 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_InboundItemTable = _resolveComponent("InboundItemTable")!
  const _component_MBDatatablePlus = _resolveComponent("MBDatatablePlus")!
  const _component_InboundReceivingPackageModal = _resolveComponent("InboundReceivingPackageModal")!
  const _component_EditModal = _resolveComponent("EditModal")!
  const _component_ImportFileModal = _resolveComponent("ImportFileModal")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.options.defaultWarehouse.name), 1),
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.options.defaultWarehouse.country), 1),
          _createVNode(_component_el_popover, {
            placement: "top",
            width: "auto",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.options.defaultWarehouse.address), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_9), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.checkedCompanys.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("inbound.receivePackage")), 1)
                ])), [
                  [_directive_auth, { auth: ['add', 'update'] }]
                ]),
                _createVNode(_component_el_date_picker, {
                  class: "w-375px bg-light-gray",
                  modelValue: _ctx.options.received_date,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.options.received_date) = $event)),
                  type: "daterange",
                  clearable: "",
                  "start-placeholder": _ctx.t('inbound.receivedDateStart'),
                  "end-placeholder": _ctx.t('inbound.receivedDateEnd'),
                  onChange: _ctx.filterChange
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "onChange"]),
                (0)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      class: "flex-fill",
                      modelValue: _ctx.options.relation_id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.options.relation_id) = $event)),
                      filterable: "",
                      clearable: "",
                      "remote-show-suffix": "",
                      remote: "",
                      "remote-method": _ctx.searchMerchantSourceItems,
                      loading: _ctx.options.merchantLoading,
                      placeholder: _ctx.t('order.merchant'),
                      onChange: _ctx.filterChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "remote-method", "loading", "placeholder", "onChange"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_select, {
                  class: "w-175px",
                  modelValue: _ctx.options.warehouse_inbound_status,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.options.warehouse_inbound_status) = $event)),
                  clearable: "",
                  "collapse-tags": "",
                  multiple: "",
                  placeholder: _ctx.t('common.status'),
                  onChange: _ctx.filterChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.status, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "onChange"]),
                (0)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-bg-light btn-active-color-primary",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end",
                        disabled: _ctx.disabledExportPackageMismatchedReports || _ctx.loading
                      }, [
                        (_ctx.disabledExportPackageMismatchedReports)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                          : (_openBlock(), _createElementBlock("i", _hoisted_17))
                      ], 8, _hoisted_15),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_permission_common, { role: { auth: ['import'] } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("common.import")), 1)
                            ]),
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", {
                                class: "menu-link px-3",
                                ":class": {
                    disabled: _ctx.loading,
                  },
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_import_file",
                                style: {"font-size":"normal"}
                              }, _toDisplayString(_ctx.t("inbound.importPackages")), 9, _hoisted_23)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.t("common.export")), 1)
                            ]),
                            _hoisted_26,
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menu-link px-3", {
                        disabled:
                          _ctx.disabledExportPackageMismatchedReports || _ctx.loading,
                      }]),
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fileExportPackageMismatchedReports && _ctx.fileExportPackageMismatchedReports(...args))),
                                style: {"font-size":"normal"}
                              }, [
                                (
                          _ctx.disabledExportPackageMismatchedReports && !_ctx.loading
                        )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("stockIn.exportPackageMismatchedReports")), 1)
                              ], 2)
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])), [
                      [_directive_auth, { auth: ['export', 'import'] }]
                    ])
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_MBDatatablePlus, {
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-sub": _withCtx(({ row: item }) => [
            (_openBlock(), _createBlock(_component_InboundItemTable, {
              key: item.id,
              skuId: item.id
            }, null, 8, ["skuId"]))
          ]),
          "cell-batch_number": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, _toDisplayString(item.batch_number), 1),
              _createVNode(_component_el_popover, {
                placement: "top",
                width: "auto",
                trigger: "hover"
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.CommonArrayToString(item.request_number)), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.CommonArrayToString(item.request_number)), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          "cell-chk": _withCtx(({ row: item }) => [
            (item.damaged)
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top",
                  width: "auto",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (item.damaged == _ctx.InboundDamagedStatus.Intact)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                          ]))
                        : (
                    item.damaged == _ctx.InboundDamagedStatus.SlightlyDamaged
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                            ]))
                          : (item.damaged == _ctx.InboundDamagedStatus.SevereDamaged)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen063.svg" })
                              ]))
                            : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.__show.damaged) + " ", 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          "cell-source": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, _toDisplayString(item.source.merchant_name), 1),
              _createElementVNode("div", _hoisted_34, _toDisplayString(item.source.channel_type), 1)
            ])
          ]),
          "cell-tracking": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, _toDisplayString(item.relation_shipment.tracking_no), 1),
              _createElementVNode("div", _hoisted_35, _toDisplayString(item.relation_shipment.__show.service_provider), 1)
            ])
          ]),
          "cell-scheduled_date": _withCtx(({ row: item }) => [
            (
              item.relation_shipment.schedule_date &&
              item.status !== _ctx.InboundStatus.Received
            )
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top",
                  width: "auto",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (
                      _ctx.getDiffDays(item.relation_shipment.schedule_date) >= 0
                    )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (
                        _ctx.getDiffDays(item.relation_shipment.schedule_date) > 0
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.t("common.inDays", [
                          _ctx.getDiffDays(item.relation_shipment.schedule_date),
                        ])), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.t("common.today")), 1))
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.t("common.agoDays", [
                        _ctx.getLateDays(item.relation_shipment.schedule_date),
                      ])), 1))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatDateTime(
                  item.relation_shipment.schedule_date,
                  "YYYY-MM-DD HH:mm"
                )) + " ", 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          "cell-received_date": _withCtx(({ row: item }) => [
            (item.received_date && item.__show.receiver)
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top",
                  width: "auto",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(item.received_date)), 1)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.__show.receiver) + " ", 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.formatDate(item.received_date)), 1))
          ]),
          "cell-quantity": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.relation_shipment.quantity), 1)
          ]),
          "cell-status": _withCtx(({ row: item }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge text-uppercase", _ctx.getInboundStatusMap(item.status)])
            }, _toDisplayString(item.__show.status), 3)
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              onClick: ($event: any) => (_ctx.editItem(item.id)),
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
            }, [
              _createElementVNode("span", _hoisted_41, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
              ])
            ], 8, _hoisted_40)), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ]),
    _createVNode(_component_InboundReceivingPackageModal, {
      ref: "receivingPackageRef",
      subTitle: _ctx.options.defaultWarehouse.name,
      onUpdateList: _ctx.updateList,
      onShowEdit: _ctx.editItem
    }, null, 8, ["subTitle", "onUpdateList", "onShowEdit"]),
    _createVNode(_component_EditModal, {
      ref: "editRef",
      itemId: _ctx.itemId,
      onResetForm: _ctx.handleResetItem,
      onUpdateList: _ctx.updateList,
      onShowReceivingPackage: _ctx.showReceivingPackage
    }, null, 8, ["itemId", "onResetForm", "onUpdateList", "onShowReceivingPackage"]),
    _createVNode(_component_ImportFileModal, {
      uploadUrl: _ctx.options.uploadUrl,
      onUpdateList: _ctx.updateList
    }, null, 8, ["uploadUrl", "onUpdateList"])
  ], 64))
}